import React, { Component } from 'react'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import { Link } from 'react-router-dom'
import { getInvoice } from '../../lib'
import moment from 'moment'

class Billing extends Component {
  constructor (props) {
    super(props)
    this.state = {
      invoice: []
    }
  }

  componentDidMount = async () => {
    const invoice = (await getInvoice()).invoice.data
    console.log(invoice)
    this.setState({
      invoice: invoice
    })
  }

  render () {
    return (
      <div className="pl3 h-100" style={{color: '#6B7C93'}}>
        <div className="flex items-center mb3">
          <Link
            to={'/admin/settings/manage-plans'}
            className="link">
        <span className="pr2" style={{fontSize: 24, opacity: 0.37}}>
          プラン
        </span>
          </Link>
          <Arrow className="pr2" style={{fill: '#c6ced7'}}/>
          <span style={{fontSize: 24}}>
        支払い履歴
      </span>
        </div>
        <Table>
          <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn style={{fontSize: 14, color: '#6B7C93'}}>
                日付
              </TableHeaderColumn>
              <TableHeaderColumn style={{fontSize: 14, color: '#6B7C93'}}>
                金額
              </TableHeaderColumn>
              <TableHeaderColumn style={{fontSize: 14, color: '#6B7C93'}}>
                領収書pdf
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.state.invoice && this.state.invoice.map(row => {
              return (
                <TableRow>
                  <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                    {moment.unix(row.date).format('YYYY-MM-DD')}
                  </TableRowColumn>
                  <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                    {row.amount_paid}円
                  </TableRowColumn>
                  <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                    <a href={row.invoice_pdf}>ダウンロード</a>
                  </TableRowColumn>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
    )
  }

}

export default Billing



// WEBPACK FOOTER //
// ./src/routes/Billing/index.js